import {
  ComponentPropsWithoutRef,
  ForwardedRef,
  ReactNode,
  forwardRef,
} from 'react';

import classNames from 'classnames';

import { Label } from '@/components/FormElements';

type RadioSizeType = 'md' | 'lg';

export interface RadioProps
  extends Omit<ComponentPropsWithoutRef<'input'>, 'size'> {
  id: string;
  label: ReactNode;
  checked: boolean;
  size?: RadioSizeType;
}

export const Radio = forwardRef<HTMLInputElement, RadioProps>(function Radio(
  { label, size, ...props }: RadioProps,
  ref: ForwardedRef<HTMLInputElement>,
) {
  return (
    <div className="relative inline-flex items-center gap-2 group">
      <div
        className={classNames(
          'shrink-0 grow-0 flex items-center justify-center',
          size === 'md' && 'w-4 h-4',
          size === 'lg' && 'w-5 h-5',
          {
            'group-hover:text-gray-300': !props.disabled,
          },
        )}
      >
        <input type="radio" ref={ref} {...props} />
      </div>
      <Label htmlFor={props.id}>{label}</Label>
    </div>
  );
});
